import { useState, useEffect } from "react";

// Puntos de corte únicos para toda la app. Deben ir en paralelo con los
// @media de constants.js: si aquí decimos "móvil < 768" y allí el media dice
// otra cosa, salen layouts híbridos imposibles de depurar.
export const BP = { xs: 480, sm: 768, md: 1024, lg: 1280 };

function leer() {
  const w = window.innerWidth;
  const h = window.innerHeight;
  return {
    w, h,
    isXS:      w <= BP.xs,
    isMobile:  w <  BP.sm,               // teléfono: sidebar en cajón
    isTablet:  w >= BP.sm && w < BP.md,  // tablet: sidebar en raíl de iconos
    isCompact: w <  BP.md,               // teléfono o tablet
    isLaptop:  w >= BP.md && w < BP.lg,
    // Móvil tumbado: ancho de sobra pero apenas alto. La cabecera, las
    // subcabeceras y el pie se comen la pantalla si no se compactan.
    isShort:   h <= 520,
    // Pantalla tactil sin raton: el "asomar" del sidebar al pasar por encima
    // no sirve ahi (mouseenter se dispara al tocar y mouseleave no llega
    // nunca, asi que el menu se quedaba abierto tapando el contenido).
    hover:     window.matchMedia("(hover:hover)").matches,
  };
}

// Un único listener por componente que lo use. `orientationchange` va aparte
// de `resize` porque en iOS el resize llega antes de que se actualicen las
// medidas y dejaba el layout con las dimensiones de la orientación anterior.
export default function useViewport() {
  const [vp, setVp] = useState(leer);
  useEffect(() => {
    let raf = 0;
    const fn = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => setVp(leer())); };
    window.addEventListener("resize", fn);
    window.addEventListener("orientationchange", fn);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", fn);
      window.removeEventListener("orientationchange", fn);
    };
  }, []);
  return vp;
}
